import {reverseString} from './StringUtils';

export const isNumber = value => !isNaN( parseInt( value, 10 ) );

export function toCurrency ( val, round_decimal = false ) {
    const num = Number( val );
    const decimal = round_decimal ? 0 : 2;

    if ( isNaN( num ) ) {
        throw new Error( `NumberUtil.toCurrency expects a number but received ${num} instead` );
    }

    let n = bankersRound( num, decimal ).toFixed( decimal );
    // convert currency to a string, add commas every 3 digits from left to right by reversing string
    n = reverseString( n );
    n = n.replace( /(\d{3})(?=\d)/g, '$1,' );
    return reverseString( n );
}

export function bankersRound ( n, d = 2 ) {
    const x = n * Math.pow( 10, d );
    const r = Math.round( x );
    const br = Math.abs( x ) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
    return br / Math.pow( 10, d );
}

export function currencyToFloat ( value ) {
    let v = value;
    if ( typeof v === 'string' ) {
        if ( v.startsWith( '$' ) ) {
            v = v.substr( 1 );
        }
        v = v.replace( ',', '' );
    }

    return parseFloat( v );
}